import { useState, useEffect, useMemo } from 'react';
import './App.css';
import FeatureLayer from '@arcgis/core/layers/FeatureLayer'
import ClosureGrid from "./ClosureGrid";
import Header from "./Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGlobe } from '@fortawesome/free-solid-svg-icons';

function App() {
  const closureLayer=new FeatureLayer("https://gis.northcharleston.org/portal/sharing/servers/508cc2d9743d4e998a1859d638c48217/rest/services/MEOC_Event/WindshieldViewOnly/FeatureServer/2")
  const [closures, setClosures]=useState([]);

  useEffect(()=>{
    const loadClosures=async()=>{
      let q=closureLayer.createQuery()
      q.outFields=["*"]
      q.returnGeometry = false
      q.where="Status='Active'"
        
      closureLayer.queryFeatures(q).then(function(results){
        var closedArray=[]
        for(var i=0; i<results.features.length; ++i){
          var road=results.features[i].attributes
          closedArray.push(road)
        }
        setClosures(closedArray)
        
      }, function(error){
        console.log(error)
      })

    }
    loadClosures()
  },[]);

  

  const defaultColDef=useMemo(()=>({
    sortable:true,
    filter:true,
    editable:false,
    resizable:true
    
    
  }),[])

  const handleClick=()=>{
    window.open("https://gis.northcharleston.org/portal/apps/experiencebuilder/experience/?id=2e2622ca057d4fa19316f8af7594a54c", "_blank" )
  }

  return (
    <div className='App'>
      <Header />
      
      <span className="closureGrid" >
        <ul>
          <li><button onClick={handleClick} className='button'><FontAwesomeIcon icon={faGlobe} className='globeIcon' />View Map</button>
          </li>
          <li><ClosureGrid closures={closures} defaultColDef={defaultColDef}/></li>
        </ul>
      </span>
    </div>
  );
}

export default App;
